import { useFocusRing as useFocusRingAria } from '@react-aria/focus';
if (process.env.NODE_ENV === 'test') {
    if (typeof window !== 'undefined') {
        // @ts-expect-error
        window.MutationObserver = class {
            constructor() {
                this.disconnect = () => ({});
                this.observe = () => ({});
                this.takeRecords = () => [];
            }
        };
        global.MutationObserver = window.MutationObserver;
    }
}
export const useFocusRing = () => {
    const { isFocusVisible, focusProps } = useFocusRingAria();
    return { isFocusVisible, focusProps };
};
//# sourceMappingURL=useFocusRing.js.map